import { useAppSelector } from '../app/hooks';
import React from 'react';
import getThemeLookup from '../selectors/getThemeLookup';
import combineStyles from '../utils/combineStyles';
import { useTranslation } from 'react-i18next';
import { CONTAINER_PROPERTIES } from '../utils/theme';
import RedcatMapPinIcon from './icons/redcat/RedcatMapPinIcon';

interface DeliveryAddressSelectedProps {
  onClick?: () => void;
  transparent?: boolean;
}

export const DeliveryAddressSelected = ({ onClick, transparent }: DeliveryAddressSelectedProps) => {
  const p = useAppSelector(getThemeLookup);
  const { t } = useTranslation();
  const formState = useAppSelector(state => state.deliveryAddressForm);

  const iconColor = p('savedAddressIcon', ['color']).color;

  const getAddressText = () => {
    if (!formState.selectedAddress) {
      return <div>{t('deliveryAddress.addressCouldNotFindInformation')}</div>;
    }

    if (
      formState.selectedAddress.displayAddress.firstLine &&
      formState.selectedAddress.displayAddress.secondLine
    ) {
      return (
        <>
          <div>{formState.selectedAddress.displayAddress.firstLine}</div>
          <div>{formState.selectedAddress.displayAddress.secondLine}</div>
        </>
      );
    }

    return <div>{formState.selectedAddress.formattedAddress}</div>;
  };

  return (
    <div
      style={combineStyles(
        styles.selectedAddress,
        p('selectedAddress', CONTAINER_PROPERTIES),
        transparent && { backgroundColor: 'transparent' },
      )}
      onClick={onClick}
    >
      <span style={styles.markerIcon}>
        <RedcatMapPinIcon size={32} color={iconColor} />
      </span>
      <div style={styles.addressText}>{getAddressText()}</div>
      <button style={styles.editButton}>{t('deliveryAddress.edit')}</button>
    </div>
  );
};

const styles: Styles = {
  selectedAddress: {
    padding: 16,
    borderRadius: 8,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  markerIcon: {
    marginRight: 14,
    display: 'flex',
    flexShrink: 0,
    alignItems: 'center',
  },
  addressText: {
    display: 'flex',
    flex: 1,
    minWidth: 0,
    flexDirection: 'column',
    justifyContent: 'center',
  },
  editButton: {
    marginLeft: 12,
    flexShrink: 0,
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    padding: 0,
  },
};
